import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Workers from './pages/Workers';
import Teams from './pages/Teams';
import Items from './pages/Items';
import Installations from './pages/Installations';
import WorkerReports from './pages/WorkerReports';
import UserManagement from './pages/UserManagement';
import Layout from './components/Layout';
import { authService } from './services/api';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    const authenticated = await authService.isAuthenticated();
    setIsAuthenticated(authenticated);
    setLoading(false);
  };

  const handleLogin = () => {
    setIsAuthenticated(true);
  };

  const handleLogout = async () => {
    await authService.logout();
    setIsAuthenticated(false);
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <Routes>
      <Route
        path='/login'
        element={
          isAuthenticated ? (
            <Navigate to='/' replace />
          ) : (
            <Login onLogin={handleLogin} />
          )
        }
      />
      <Route
        path='/'
        element={
          isAuthenticated ? (
            <Layout onLogout={handleLogout} />
          ) : (
            <Navigate to='/login' replace />
          )
        }
      >
        <Route index element={<Dashboard />} />
        <Route path='workers' element={<Workers />} />
        <Route path='teams' element={<Teams />} />
        <Route path='items' element={<Items />} />
        <Route path='installations' element={<Installations />} />
        <Route path='worker-reports' element={<WorkerReports />} />
        <Route path='user-management' element={<UserManagement />} />
      </Route>
    </Routes>
  );
}

export default App;

